import { mapObjectToList } from '../utils';
import { merge } from 'lodash';

const initialState = {
  data: {},
};

const helpers = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'INSTALLER_RESOURCE_SUCCESS':
    case 'INSTALLER_RESOURCE_CREATE_SUCCESS':
    case 'INSTALLER_RESOURCE_UPDATE_SUCCESS': {
      const helper = payload.entities && payload.entities.helpers;
      return merge({}, state, { data: helper });
    }
    default:
      return state;
  }
};

export default helpers;

export const helperList = state => mapObjectToList(state.data);
export const getById = state => id => state.data[id];



// WEBPACK FOOTER //
// ./client/app/reducers/helpers.js